export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/AiNumberReader.worker.a6a6ecc4.worker.js");
}
